import { DateTimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import EnderecoEdit from "components/endereco/EnderecoEdit";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Coleta from "model/transportes/coleta/Coleta";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import "react-hook-form";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import ColetaService from "service/transportes/ColetaService";
import { pessoaCompleteMethod } from "utils/autocompleteUtils";
import { converterDataHora } from "utils/convert";

const coletaService = new ColetaService();

export default function ColetaCadastro() {

    const [queryParameters] = useSearchParams();

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [coleta, setColeta] = useState<Coleta>(new Coleta());
    const [titulo, setTitulo] = useState<string>('Coleta');


    useEffect(() => {
        coletaService.clientes().then((data) => {
            setClientes(data);
        }).catch(err => {
            console.log(err);
        })
    }, []);

    const [clientes, setClientes] = useState<Pessoa[]>([]);
    const [clientesFiltrados, setClientesFiltrados] = useState<Pessoa[]>([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    function validar() {
        return true;
    }
    function validarPersonalizado() {

        if (!coleta.cliente || !coleta.cliente.id) {
            setError("cliente", { type: "manual", message: "Cliente é obrigatório" }, { shouldFocus: true });
            return false;
        }
        if (!coleta.endereco) {
            msgErro("Endereço", "Endereço é Obrigatório")
            return false;
        }
        if (coleta.endereco && !coleta.endereco.latitude) {
            msgErro("Endereço", "Selecione um endereço no mapa ou na busca",)
            return false;
        }

        return true;
    }

    return (

        <BaseCadastro model={coleta} service={coletaService} setModel={(value: Coleta) => setColeta(value)} validar={() => validar()} validarPersonalizado={() => validarPersonalizado()} urlService="/coleta" pathCadastro="/coleta" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}
            <TabView>
                <TabPanel header="Dados" contentStyle={{ paddingLeft: 10 }} >
                    <div className="row">
                        <Label className="col col-sm-12">Número</Label>
                        <div className="col-sm-12">
                            <InputText value={coleta.numero + ""} disabled />
                        </div>
                        {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Cliente</Label>
                        <div className="col-sm-12">
                            <AutoComplete
                                className={errors.cliente ? "p-invalid" : ""}
                                value={coleta.cliente}
                                style={{ width: '300px' }} inputStyle={{ width: '100%' }}
                                suggestions={clientesFiltrados}
                                completeMethod={(e) => {
                                    let filtered = pessoaCompleteMethod(clientes, e.query)
                                    setClientesFiltrados(filtered)
                                }}
                                field="nome"
                                dropdown
                                onChange={(e) => {
                                    clearErrors("cliente")
                                    let coletaLocal = JSON.parse(JSON.stringify(coleta));

                                    if (!e.target.value) {
                                        coletaLocal.cliente = null;
                                    } else if (typeof e.target.value == "string") {
                                        let cliente = new Pessoa();
                                        cliente.nome = e.target.value;
                                        coletaLocal.cliente = cliente;
                                    } else {
                                        coletaLocal.cliente = e.target.value;
                                    }
                                    setColeta(coletaLocal);
                                }} />
                        </div>
                        {errors.cliente && errors.cliente.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.cliente?.message as string}</span> : null}
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12" >Data prevista</Label>
                        <DateTimePicker
                            sx={{ width: '300px' }}
                            value={dayjs(coleta.dataPrevista)}
                            ampm={false}
                            format={"DD/MM/YYYY HH:mm"}
                            onChange={value => {
                                setColeta({ ...coleta, dataPrevista: value?.toDate() || null })
                            }} />
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12" >Data realizada</Label>
                        <InputText className="col-sm-12" style={{ width: '300px' }} value={converterDataHora(coleta.dataRealizada)} disabled />
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12" >Observação</Label>
                        <InputTextarea className="col-sm-12" style={{ width: '300px' }} value={coleta.observacao} onChange={(e) => setColeta({ ...coleta, observacao: e.target.value })} />
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12" >Observação motorista</Label>
                        <InputTextarea className="col-sm-12" style={{ width: '300px' }} value={coleta.observacaoMotorista} disabled />
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12" >Status</Label>
                        <InputText className="col-sm-12" style={{ width: '300px' }} value={coletaService.getStatusLabel(coleta.status)} disabled />
                    </div>
                </TabPanel>
                <TabPanel header="Endereço" >
                    <EnderecoEdit value={coleta.endereco} onChange={(e) => setColeta({ ...coleta, endereco: e })} />
                </TabPanel>
            </TabView>

        </BaseCadastro>
    )
}
